/*=============================================== NavList component ===============================================*/

import { useState } from "react"
import { NavLink } from "react-router-dom"
import classNames from "classnames"
import { unslugify, slugify } from "tsx-library-julseb"

import {
    StyledNavList,
    CategoryButton,
    ChevronDown,
} from "components/layouts/NavList/styles"
import type { NavListProps } from "components/layouts/NavList/types"

import { allPages } from "data"

const NavList = ({ category }: NavListProps) => {
    const [isOpen, setIsOpen] = useState(true)

    const pages = allPages.filter(page => page.category === category)

    return (
        <StyledNavList className={classNames({ open: isOpen })}>
            <CategoryButton onClick={() => setIsOpen(!isOpen)}>
                {unslugify(category)}

                <ChevronDown
                    src="chevron-down"
                    className={classNames({ open: isOpen })}
                />
            </CategoryButton>

            {pages.map(({ title }) => (
                <NavLink to={`/${category}/${slugify(title)}`} key={title}>
                    {title}
                </NavLink>
            ))}
        </StyledNavList>
    )
}

export default NavList
